import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import { themeColor } from '../Theming';
import images from '../Theming/images';
import { hasSliideOrigin } from '.';
import { addSliideText } from './PartnerPluginActivateMultiStep';
import { MultiStepStyledButton } from './PartnerPluginActivateMultiStepAlmostThere';
import { useQuery } from '../Common/Hooks';
import clsx from 'clsx';

const SubTitleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: normal;
  margin-top: 20px;
`;

const SubTitleText = styled.div`
  color: ${themeColor('darkestGrey')};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  width: 310px;
`;

const LinkText = styled.a`
  color: ${themeColor('blue')};
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 320px;
  margin-top: 21px;
  margin-left: 35px;
  min-height: 500px;
`;

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
`;

const StyledImage = styled.img`
  width: 280px;
  height: 32px;
`;

const PartnerPluginActivateMultiStepStartShopping = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const [sliide] = useState(hasSliideOrigin());

  const openApp = useCallback(() => {
    const origin = query.get('origin');
    if (origin)
      window.location = `${origin}://` as (string | Location) & Location;
  }, [query]);

  return (
    <MultiStepActivationContainer
      headerTextColor="white"
      headerText={
        'PartnerpluginsdkActivate.multiStep.startShoppingAndSaving' +
        addSliideText(sliide)
      }
      headerTextTopPadding={20}
      sliide={sliide}
      gradientBackground="linear-gradient(147deg, #8B2488 2.25%, #16C1FF 66.76%)"
    >
      <BodyContentContainer>
        <SubTitleTextContainer>
          <SubTitleText>
            <Trans
              t={t}
              i18nKey="PartnerpluginsdkActivate.multiStep.youHaveAccess"
            >
              <LinkText>AbsoluteText</LinkText>
            </Trans>
          </SubTitleText>
        </SubTitleTextContainer>
        <StyledImageContainer>
          <StyledImage
            src={
              sliide
                ? images.partnerpluginsdk_start_shopping_brands_sliide?.default
                : images.partnerpluginsdk_start_shopping_brands?.default
            }
            alt={'brands'}
          />
        </StyledImageContainer>
        <SubTitleTextContainer>
          <SubTitleText>
            <Trans
              t={t}
              i18nKey="PartnerpluginsdkActivate.multiStep.shopAndAddItems"
            >
              <LinkText>AbsoluteText</LinkText>
            </Trans>
          </SubTitleText>
        </SubTitleTextContainer>
        <SubTitleTextContainer>
          <SubTitleText>
            <Trans
              t={t}
              i18nKey={
                'PartnerpluginsdkActivate.multiStep.goToAppToView' +
                addSliideText(sliide)
              }
            >
              <LinkText>AbsoluteText</LinkText>
            </Trans>
          </SubTitleText>
        </SubTitleTextContainer>
        <StyledImageContainer>
          <MultiStepStyledButton className={clsx({ sliide })} onClick={openApp}>
            {t('PartnerpluginsdkActivate.multiStep.goAppToApp')}
          </MultiStepStyledButton>
        </StyledImageContainer>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerPluginActivateMultiStepStartShopping;
